<template>
  <div class="brand-list">

    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1"> -->
    <div class="item-box" v-if="brandList">
      <van-row class="list">
        <!-- <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in brandList" :key="index" :itemInfo="itemInfo"></itemInfo> -->
        <div class="brand-top" v-for="(itemInfo,index) in brandList" @click="nvaToDetail(itemInfo.id)" :key="index">
          <!-- <div class="brand-title">{{itemInfo.name}}</div> -->
          <img :src="itemInfo.picUrl" alt="">
        </div>

      </van-row>
    </div>
    <!-- </van-list>
    </van-pull-refresh> -->
  </div>
</template>

<script>
import itemInfo from "@/components/itemInfo";

import { brandList } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "brandDealer",
  components: {
    itemInfo,
  },
  data() {
    return {
      brandList: [],
      isLoading: true,
      loading: false,
      finished: false,
      data: {
        page: 0,
        size: 10,
      },
    };
  },
  mounted() {
    this.getbrandList();
  },
  methods: {
    nvaToDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/brandDetail",
        name: "品牌商详情",
        query: {
          id: id,
        },
      });
    },
    // onRefresh() {
    //   Toast("刷新成功");
    //   this.isLoading = false;
    //   this.brandList = [];
    //   this.data = {
    //     page: 0,
    //     size: 10
    //   };
    //   this.finished = false;
    // },
    // onLoad() {
    //   // 异步更新数据
    //   const nextPaging = {
    //     page: this.data.page + 1,
    //     size: 10
    //   };
    //   this.data = nextPaging;
    //   this.getbrandList(this.data);
    // },
    getbrandList(data) {
      brandList(data).then((res) => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          //   this.brandList = this.brandList.concat(newOfRes.brandList);
          this.brandList = newOfRes.brandList;
          //   this.loading = false;
          // // 数据全部加载完成
          //   if (this.brandList.length == newOfRes.count) {
          //     this.finished = true;
          //   }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    navToDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.brand-list {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  .brand-top {
    position: relative;
    // height: 13.9rem;
    width: 100%;
    margin-bottom: 1.6rem;
    border-radius: 5px;
    overflow: hidden;
    .brand-title {
      position: absolute;
      top: 3rem;
      // text-decoration: underline;
      width: 100%;
      left: 50%;
      margin-left: -50%;
      color: #fff;
      font-size: 1.8rem;
      font-family: 534-CAI978;
      font-size: 3.2rem;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 3.2rem;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .brand-name {
    height: 3rem;
    line-height: 3rem;
  }
}
.item-box {
  width: 91.5%;
  padding-bottom: 1rem;
  margin: 1.6rem auto 0;

  .list {
    width: 100%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index/brandList.vue